import { render } from "./Placeholder.vue?vue&type=template&id=6fed8796&scoped=true"
import script from "./Placeholder.vue?vue&type=script&lang=js"
export * from "./Placeholder.vue?vue&type=script&lang=js"

import "./Placeholder.vue?vue&type=style&index=0&id=6fed8796&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6fed8796"

export default script